import { render } from "./ManageLearningCourseSettings.vue?vue&type=template&id=4ed103a2&lang=pug"
import script from "./ManageLearningCourseSettings.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourseSettings.vue?vue&type=script&lang=js"

import "./ManageLearningCourseSettings.vue?vue&type=style&index=0&id=4ed103a2&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__